import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('toggle-button', {
  root: {
    variants: {
      skin: [
        'standard',
        'dark',
        'inverted',
        'destructive',
        'success',
        'standard-secondary',
      ],
      labelPlacement: ['tooltip', 'end', 'start', 'bottom'],
      shape: ['square', 'round', 'pill'],
      size: ['tiny', 'small', 'medium', 'large'],
    },
    states: [
      'selected',
      'interactive',
      'disabled',
      'mobile',
      'hasIcon',
      'border',
      'iconOnly',
    ],
  },
  tooltip: {
    states: ['disabled', 'interactive'],
  },
  btnContent: {},
  labelContainer: {},
  icon: {},
  rootIcon: {},
  label: {},
});
